export default "__VITE_ASSET__D3A2K0GM__"